import { useTheme } from 'contexts/ThemeContext';
import React, { useEffect } from 'react';
import { Image, ImageSourcePropType, Text, TouchableOpacity, View, } from 'react-native';
import { IImage } from 'styles/images';
import styleSheet from './styles'

export interface ReactionButtonProps {
    onPress: () => void;
    reaction: string;
}

const ReactionButton = (props: ReactionButtonProps) => {
    const styles = styleSheet(useTheme());

    return (
        <TouchableOpacity
            hitSlop={{ top: 10, left: 10, right: 10, bottom: 10 }}
            style={styles.container}
            onPress={props.onPress}>
            <Text style={styles.reaction}>{props.reaction}</Text>
        </TouchableOpacity>
    )
};

export default ReactionButton;
